module.exports = __webpack_public_path__ + "static/grafika5@2x-2fb40ce0bda5dba854aec274eca883ad.png";